"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*!
Amazon Kinesis Video Streams WebRTC SDK for JavaScript
Copyright 2019-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.

This product includes software developed at
Amazon Web Services, Inc. (http://aws.amazon.com/).
*/
var Role_1 = require("./Role");
exports.Role = Role_1.Role;
var SignalingClient_1 = require("./SignalingClient");
exports.SignalingClient = SignalingClient_1.SignalingClient;
var SigV4RequestSigner_1 = require("./SigV4RequestSigner");
exports.SigV4RequestSigner = SigV4RequestSigner_1.SigV4RequestSigner;
exports.VERSION = process.env.PACKAGE_VERSION;
//# sourceMappingURL=index.js.map